import { render, staticRenderFns } from "./FuncionariosModal.vue?vue&type=template&id=7dfa0b09"
import script from "./FuncionariosModal.vue?vue&type=script&lang=js"
export * from "./FuncionariosModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports